import React from "react";

import PropTypes from 'prop-types';

import './style.scss'; 

function BaseButton ({ className, noHover, text="Lets talk", onClick, type="button" }) {
    return (
        <button 
            className={`default-btn ${className ? className : ''} ${noHover ? 'no-hover' : ''}`}
            onClick={onClick}
            type={type}
        >
          {text}
        </button>
    )
}

BaseButton.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
  noHover: PropTypes.bool,
  onClick: PropTypes.func,
  type: PropTypes.string
};

export default BaseButton;